import { aggregateBlockers } from "@nexus/contracts";
import type { CriterionBlocker } from "@nexus/contracts";

import type {
  PreflightReportAsset,
  PreflightReportDetail,
} from "../types/preflight.types";

export type { CriterionBlocker };

function isScored(asset: PreflightReportAsset): boolean {
  return asset.status === "SCORED" && asset.score != null;
}

/** Scored creatives only — an unscored asset carries no verdicts to aggregate. */
export function scoredReportAssets(
  report: PreflightReportDetail,
): PreflightReportAsset[] {
  return report.assets.filter(isScored);
}

export function scoredAssetCount(report: PreflightReportDetail): number {
  return scoredReportAssets(report).length;
}

/**
 * Rank the criteria hurting scores most across a set of scored creatives. The market
 * dashboard reads the equivalent ranking off the aggregate response instead of
 * recomputing it here.
 */
export function computeTopBlockers(
  assets: readonly PreflightReportAsset[],
  limit?: number,
): CriterionBlocker[] {
  return aggregateBlockers(
    assets.map((asset) => asset.features),
    limit,
  );
}
